import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useThemedLogo } from "components/hooks/useThemedLogo";

export const InvitePage = () => {
  const Logo = useThemedLogo();
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) {
      setError("Invalid invitation link");
      setLoading(false);
      return;
    }
    navigate(`/register?token=${token}`, { replace: true });
  }, [token, navigate]);

  if (loading) {
    return (
      <section className="auth-page">
        <div className="flex flex-col justify-center min-h-full px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <div className="items-center text-center">
              <Logo className="w-18 h-18 mx-auto" aria-label="Logo" />
            </div>
            <h2 className="mt-2 tracking-tight text-center text-fg-title">
              Validating invitation...
            </h2>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="auth-page">
        <div className="flex flex-col justify-center min-h-full px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <div className="items-center text-center">
              <Logo className="w-18 h-18 mx-auto" aria-label="Logo" />
            </div>
            <h2 className="mt-2 tracking-tight text-center text-fg-title">
              Invalid Invitation
            </h2>
            <p className="mt-4 text-center text-error">{error}</p>
            <div className="mt-6 text-center">
              <button
                onClick={() => navigate("/")}
                className="text-fg-muted-regular underline cursor-pointer"
              >
                Return to login
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
};
